import React from 'react';
import { toDateString } from '../../../utils/formatting';
import CalendarInputBase from './CalendarInputBase';

const DateInput = ({
  field,
  fieldId,
  value,
  onChange,
  label,
  isRequired,
  error,
  language
}) => {
  const dateValue = value ? (value.substring(0, 10)) : '';

  const handleDateSelect = (date) => {
    const dateString = toDateString(date);
    onChange(fieldId, dateString);
  };

  const initialMonth = value ? new Date(value) : new Date();

  return (
    <CalendarInputBase
      field={field}
      fieldId={fieldId}
      displayValue={dateValue}
      onDateSelect={handleDateSelect}
      label={label}
      isRequired={isRequired}
      error={error}
      initialMonth={initialMonth}
      minDate={field.min}
      maxDate={field.max}
      iconInsideInput={true}
      language={language}
    />
  );
};

export default DateInput;